import _get from 'lodash/get';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong';

export const getErrorMessage = (error, defaultMessage = DEFAULT_ERROR_MESSAGE) => {
  const errorMessage = _get(
    error,
    'response.data.message',
    defaultMessage
  );

  return errorMessage;
};

export default {
  getErrorMessage
};
